/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export var LocaleUserFriendlyString;
(function (LocaleUserFriendlyString) {
    LocaleUserFriendlyString["EN_US"] = "English";
    LocaleUserFriendlyString["FR_FR"] = "Fran\u00E7ais";
    LocaleUserFriendlyString["IT_IT"] = "Italiano";
    LocaleUserFriendlyString["ES_ES"] = "Espa\u00F1ol";
})(LocaleUserFriendlyString || (LocaleUserFriendlyString = {}));
